interface ThumbnailInterface {
	[key: string]: {
		title: string;
		desc: string;
		img: string;
		src?: string;
		href?: string;
	}[];
}

export const thumbnails: ThumbnailInterface = {
	Switch: [
		
		{
			title: 'Job Updates for Elites',
			desc: 'Opportunities at Mckinsey, BCG, PwC, Meesho etc.',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiB4eASByitz5vH4DB5Yty7VdsvUuqmBS_QScPoMF4I7WkDlRWssJZnKZjWFbloS9F_hmHhK9Ny9oQQGfFuKvz4Nmm1ev-Kz1nHClP8z6rWjE1MTcZ3O_OfCDIItBU5L9lfgU2MbVuim6O9M3wqONBTOiySf9cN1dARFxoHIMOiUID-K7Yiicyagpucjg/w592-h387/image_2022-12-30_220331423.png',
			src: 'https://remotecompany.blogspot.com/2022/12/job-updates-for-top-companies.html',
		},
		{
			title: 'Top Company Career Page Links',
			desc: 'Do not waste time in remembering company names & searching their career pages, apply here directly:',
			img: 'https://i.ibb.co/sstsRDp/job-application.jpg',
			src: 'https://remotecompany.blogspot.com/2022/12/top-company-career-pages.html',
		},
		{
			title: 'List of Remote Jobs',
			desc: 'List of companies offering Remote work around the globe 🌍',
			img: 'https://i.ibb.co/XzqjtXW/Job-Searching-Online-11-Best-Practices-You-Need-to-Know-2-2.jpg',
			src: 'https://remotecompany.blogspot.com/2022/12/remote-jobs.html',
		},
		{
			title: 'Resume, Cover Letter templates by Harvard University',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhhG-g7coqnJMg9i37DUteDfy2J-b9OEZ6WTwCGL_-XpS6gYRNmKI3Nfpr5ZYEHaRRIymwMK_fcZKFxmykafAzC0eH5nNmLmLKAtCqVCbU4LTWPRRZg-KLNk-PFaZQmqYCY-eRrW_F9L7h1l4eG3ud-GlKOY_m-RxzC4Xu1PJiSN88IPklSG9LAN7cD4A/s320/resumeicon.jpg',
			src: 'https://remotecompany.blogspot.com/2023/03/resume-and-cover-letter-template-by.html',
		},
		{
			title: '101 Great Answers to The Toughest Interview Questions',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjSsRwZYHarOuUEZ7rxvYbmFDgkZoiYugy94FEdK2QgvvS3G31hpwnIENp6ySHwD8LBq-okrlgbF699_9NiNeSAOkGWgEskgLv67q31GibXmHQ7WGtc8kb2JjcCa8cwJsW96e38eaN9rPfFVfyCc4pZGH26scOHbXP-HPMXE_aIo9EUr9MwjOK8SW_6DQ/w564-h313/image_2022-12-30_132828591.png',
			src: 'https://remotecompany.blogspot.com/2022/12/101-great-answers-to-toughest-interview.html',
		},
		
	],
	'The Library': [
		{
			title: '1. DEEPWORK',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/a/AVvXsEgODib793km00oxc_fgLg1P4svJWJECS5LvAOYrtqooYZW91-94X3o2NF713tCeeI3OAt8fG952e2KGmgB8CsRuROV3oO3oxjNXygiG9aOCpbji-0JpmvPjH0J_7hJCD1aQhzlBLRd9rTB5a6m4p-spEqAd_M33fin3Xlat1ySGB4ubH_e7t5h2PjY0aw=w631-h631',
			src: 'https://summarycentral.blogspot.com/2022/12/deep-work.html',
		},
		{
			title: '2. ATOMIC HABITS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhZKq0RmgqM2BemZhrT4e0QGTEwXGRCjV5_5CW9IA1kk2pHeU2BXx5pHCvlIuaYa2LVbjCXPizAfsvpvr1VWk0j01xaakgsalNrIHTzYkZJZPwJvDo-KKnv16WvWb_Hq1P7sAKA1iXu10a5pIgSFwhOSVhzJyjXLYDuUj1A3rc3hJEhJSxj6FLJBLdNgw/w648-h410/image_2022-12-19_151516236.png',
			src: 'https://summarycentral.blogspot.com/2022/12/atomic-habits_19.html',
		},
		{
			title: '3. THE ALMANACK OF NAVAL RAVIKANT',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg437COCbqS7GiTP3Th5NajAcLiJilnBmzGAHZViRDqHybeFhbHdNorN73b1IuZzYksU31CRn17RKYxFFwW05IaE7r-PTt2w8gmxijAGgheQqm_xROcg2v-NqzQbM-FG0ly-xJaA3EPemjdcuJflols_LP3jB-L1P1AEcAcDO4EjszvGcKtBSWlc47QAw/w653-h436/image_2022-12-19_152744880.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-almanack-of-naval-ravikant.html',
		},
		{
			title: '4. SAPIENS: A BRIEF HISTORY OF HUMANKIND',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/a/AVvXsEh5R6Zt6YR8kthOzEvbVMLbfEku8d68HOuk4u03n7yFvGhM8iCU6TcJKyXelSevKzJId0S-zEUvMbJv70zHD5cpIp9xky35m-XeWq0a7g09joo8kUBLaLNaXisCGN2yteAWq6O9thfRnapFMAJVa43U5ZApNLfOSvm2pTI2DmKs8mrGhswurLS_Z7Qf9w=w425-h453',
			src: 'https://summarycentral.blogspot.com/2022/12/sapiens-brief-history-of-humankind.html',
		},
		{
			title: '5. CAN\'T HURT ME: MASTER YOUR MIND AND DEFY THE ODDS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiMaqLtW0LIXDUjXt8H_2U8FqP_iS7PC9dVcMesqpLDxilkrniAwKVcslcIA6mOQBHCaIjg6BlwuXw46S2m37gUTDO5jOgCCm6UsusvQ1IDxArRZYsmjb6Ku07FvL4bpeebiXYXj0tZ4OYMnq35MrYbwOK_S8WFZSB_qQEvzu_mj_enHAfqAusAeq4rEQ/w629-h504/image_2022-12-19_184801968.png',
			src: 'https://summarycentral.blogspot.com/2022/12/cant-hurt-me-master-your-mind-and-defy.html',
		},
		{
			title: '6. PSYCHOLOGY OF MONEY',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhch71ZyYb4P6BiLPwwB1Xug8v3PdT5Nobhn1AvccSOhW__WTuyRiaK8XdXG_iJqjXUzalJ1yb5jioTlQw5F6tWyLoXdhLqqalvEdONrwGk145tjPw52IkYlbU9vBMstzVa5BDUHoPLq3sLxQYqaV_2tFEfqXLiabhP_BFHMXMZ3mnlSoxnwqqSCPSeQg/w591-h314/image_2022-12-20_135121389.png',
			src: 'https://summarycentral.blogspot.com/2022/12/psychology-of-money.html',
		},
		{
			title: '7. THINK LIKE A MONK',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEinF-duu9_1vpUm-NNr0osHh2BqUlToiNN9wwgtZ1MkqIkm2SocXlFDX2zzq1yuYnpTH851WaxX36j_dIFHVDYaOheY2B5scnmtBs_1YPbp21y-7cXeAJkwf3pUXbAkWZlApwDmTII_pXImoszZGWWY-9zQ79qnHfHWyrfyhmal_AQRUWxnPzp1DiTPhQ/w614-h320/image_2022-12-20_142507898.png',
			src: 'https://summarycentral.blogspot.com/2022/12/think-like-monk.html',
		},
		{
			title: '8. STEVE JOBS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhHVZjPsTm1BzTbYD3lt4f5-tajHQl15ypyJjfaly_cc0O4LW8OGnHJ3Fsb_VIfzPCEsDJqOq_hBo6JTnXkltJW6POd0bgCPu6mviL-f4WwHrDl_eWfLReb50H5Bq07pLDyvx69nInyM4_fifCXUinL1ISCfPFji3FSdLMzeT1p8_K1sgp0j8VAoQQWcQ/w596-h446/image_2022-12-20_143559223.png',
			src: 'https://summarycentral.blogspot.com/2022/12/steve-jobs.html',
		},
		{
			title: '9. A CALENDAR OF WISDOM',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEge31s2Sb6Qnc2IT_VSk__uwhHpOORks6Cnao6DqKT9qfLDemF3Oy4qoG1kSdSq-SOQJooT8F-Umkb1Npb28lZOMUVi40FgNzljiu0vv3yCxg5TeZKxCkHcA0GhcsC11iB5W2e6L5aBEF7m6_uvZuOML_FTBwQeUkhHLDzwRyfNbzhhTGG7U3Ri0NcJeg/w501-h607/image_2022-12-20_152138302.png',
			src: 'https://summarycentral.blogspot.com/2022/12/a-calendar-of-wisdom.html',
		},
		{
			title: '10. 12 RULES FOR LIFE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj354wvi3UpYn4A8zMlgKWnyxglWyC_FtVg93MACzA6u8RjfF_6cQinLiL_EPaDYMsIdxsyzARMj92LXIiiIc9K5nDrUM2c7fD1cQ9edg0AqVxmImlDkFeV6qLF7l1Fc0Fp1MltQ9ZbnsCiaEpaCg4fWLH86lV3NvrQtCoWgYoD0NXeRrZX0YHMTSyzWA/w591-h443/image_2022-12-20_153933786.png',
			src: 'https://summarycentral.blogspot.com/2022/12/12-rules-for-life.html',
		},
		{
			title: '11. ON THE SHORTNESS OF LIFE: LIFE IS LONG IF YOU KNOW HOW TO USE IT',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi1jnu2WTg1Cu-bOnbxA8n6tfQSnhBlL6ibrNCnyGOxYfeVtADMc9_7eHNPZwWt4kSW_YPAk003VEHfGtzCTA0BWDh8d7ZiVK1DIZseJobjVjvGZytmie4YNeypFVly1IB5Gf52POJPnBN9txCNFYKm6OqoO2lgd_7NtrPtxwlzADsvwWqB4d8O75qBtg/w580-h580/image_2022-12-20_154709819.png',
			src: 'https://summarycentral.blogspot.com/2022/12/on-shortness-of-life-life-is-long-if.html',
		},
		{
			title: '12. THE MILLIONAIRE NEXT DOOR',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEipXDXYZJOjtDoHHqcSwBCCgNTMHvSfbc6xGVQF9hLFDh2alJtz2nKxiWyAxItTh9G-LFRuZUthzqrIILHn7qM30Xu6W0CnrDmvXmWln27ZcL5Sf-lga1KwVb5IdJZwMKI9vrfWM90BB492ZngYdZ_ugUCwP_zsa6W7v1aDMLdNsYZGNMH23hVfO0_ENg/w622-h400/image_2022-12-20_161201364.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-millionaire-next-door.html',
		},
		{
			title: '13. I WILL TEACH YOU TO BE RICH',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgJR0GBJvj4u-KmFXCWDto-q_Xyezj_xiqWurck0RB6C8Mtxwda8Em8G3DoRbCPVHn_HOqfmWj9BDAy6kMMqbnVZg8AAT85SPju4LaQsVkwtZ-u6l-YphfiG1u4Puk0lhS7fWZJWlJyN_mvlPww8WNWU-uW0MhXOflpFAKwaJIy57qWQaTepdLsrse_nA/w632-h421/image_2022-12-20_162300695.png',
			src: 'https://summarycentral.blogspot.com/2022/12/i-will-teach-you-to-be-rich.html',
		},
		{
			title: '14. THE FOUR AGREEMENTS ',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhoRTpPg-3grT295BjOGp_7GaJdJR-tOFK388EmQjipkI-e1HLo1Ckm73Fn2KwNPhdu1gFuBmV9beOLe7O350UvFFt6YwMwo9FjqWVodHn3bu0uigIe7N7HCkMUYXSrSKNHdcmf1exxpbsksded1wRKJW4gM7_J6j4rfL9s9fpPJSi-qdMUAkLnmg4d7w/w579-h579/image_2022-12-20_163521030.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-four-agreements.html',
		},
		{
			title: '15. THE POWER OF NOW',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhTh6Bi3fa9GC4IlmFhCs1AcOYUdjYIc2LreC5khG-LL-1RoUdmEZXWCIeay9WQLUFwNG8rxFxcZxkSjrhCHm1R-_l8mZP3KJvkxqpKlG_Bh5BX2b7xB7BsviTbjE3o6mRJv2-DAUULQ2Ehje_5iO3WSzGxrELwanWZA_ezFxoJCg6RujvxSeKowq4_PA/w328-h369/image_2022-12-20_171916343.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-power-of-now.html',
		},
		{
			title: '16. FACTFULNESS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh_b5KS469DNbsROIWPfDNltn64pIIWE5w5mXPPEIvUcqYNNdwItPA6nOU33JQM1zOetHmwBmsc-xkg2ViXq61EeAOcfFxnOqxkgGUsygp1lt9_bz11qw58O4fSALmDvZg2GiSEX9N84WUSKInLDTxpcDbsBEuj1v5m9Kpe_tvuI4EsZ7sdURJOBNBndA/w574-h312/image_2022-12-21_121755320.png',
			src: 'https://summarycentral.blogspot.com/2022/12/factfulness.html',
		},
		{
			title: '17. THE LESSONS OF HISTORY',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjRfKFi7WKQ7beb2uj1YdhXHGU1DhPLsx3IslSAA49ryFpXWdpeoj2l4ezrQ0ebfEdLLLWfkPaqGPCKQ9xwhk6ak8ktEogf_4zKCI_btEq8f2q1CaAm6KKQxNk7ECK20i8g_lv6MzNi5LG2RqdD_9UJ_vA_zMrEidjOGZVNeBt67xDmwEGrZNhnLC6c0w/w443-h534/image_2022-12-21_123316184.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-lessons-of-history.html',
		},
		{
			title: '18. WAR AND PEACE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhPyaPT9u07_8_JHfNaIf7hirHEHW4Wd9jE2QR49eTp1svWW-vWR9DVzlCDtVgSxgnupNr4b17amPla8Dbz30kFH8KOI1MBig7iKg7X9sjEgOf6gWiQrU-jJtmVSID9ljRjl7z1nJJ1U3wMXTJaq9GaCDV-ciqm7I3RBFRDA6oY9dsDYKc0gFfekMX47A/w534-h401/image_2022-12-21_125947700.png',
			src: 'https://summarycentral.blogspot.com/2022/12/war-and-peace.html',
		},
		{
			title: '19. THE ALCHEMIST',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhXxrbCc09LeoG7v1i5tGWJD9fP6HX5n8Lw3jRuiUB99IchOGGDwsp6FGoE4eGGTvT8OETw3Y72NncLwhAPqvZXNicwKwjvqT1ox2KGk--wKM3t-gZrjQgMkdaHQ4If_uj_ONUtCGVdfabkQw9dyLf0ow46L0hVIzpv9mvlx1lX7cRhZu576_-tE37vWg/w554-h406/image_2022-12-21_131205226.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-alchemist.html',
		},
		{
			title: '20. HOMO DEUS: A BRIEF HISTORY OF TOMORROW',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhD3V68vUkXX6unMZjfLveRekOfzNZg7mh1gWKOjVppxrluu_QLWSBaIxgfzOGaUEIXJEKweBxD36houyBKqz-ZkNijRHSKyH05VABrcC1lqJBjBFEPq9DbEz68FmILvuanuRk--tU8csm8Vn3BcRtd5ii9yuGpefXYEeJytoFvhCbiYx4cOCHMMF-nag/w456-h456/image_2022-12-21_132102474.png',
			src: 'https://summarycentral.blogspot.com/2022/12/homo-deus-brief-history-of-tomorrow.html',
		},
		{
			title: '21. 21 LESSONS FOR THE 21ST CENTURY',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhe3Vf_4V88UMVCGkVzIc6-LrGA8Pr5d30RiXX1oQlXMrPwjRNymc9XygJ6VIP5aJgiZyKtVyt9uCl3wzw_oSJlvd0rSUMMXPLtmkmGwbP2DNepQGlcAu6K8lK6J0UVCzZRt18rZ67FUPpz5xnnWO8imuNEmk5prVwDwfnesgFCiE1MpLZ48xj4bReG4Q/w605-h453/image_2022-12-21_133236909.png',
			src: 'https://summarycentral.blogspot.com/2022/12/21-lessons-for-21st-century.html',
		},
		{
			title: '22. THE POWER OF HABIT',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgGKXAv7X1XnqP4RznkC1Hdj-dRDY1l4vWhcx_uHirvbLAuNmgHMFbr3tNcSXIY96BKD75RXxGZTN7h31KJBLsUc4alsnNlCLipfVXiKRd-3HpH6_3wNdYDhKxXyKOXoAqJ9zgQ8T8mgKgylHagCSvN4fJpV_GJI5m07c1jhLhnu4LdUEvmkgepPASvRQ/w562-h562/image_2022-12-21_134701546.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-power-of-habit.html',
		},
		{
			title: '23. MAN\'S SEARCH FOR MEANING',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg-35pr-TQeWD6Jm_mb9qCupTnpiSo9AcbKydWAGb50M4RIZCQKGQFTTdf5Vx6VknRs283KPO6kFKeFdfBtgllbBFUlsyIjPHkqPhhdYfxICRh6rskP9svvNAUJMAHg7b2-ko2IUh4dMcUE4CoJXlSmoIpr2E8fRcrK-CfHSGNoR0VvqB5JsCbwlJ-dLQ/w612-h398/image_2022-12-21_135739479.png',
			src: 'https://summarycentral.blogspot.com/2022/12/mans-search-for-meaning.html',
		},
		{
			title: '24. A SHORT HISTORY OF NEARLY EVERYTHING',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhRn8C9QoHhnTUlS1ncOMnQREVpDrDTNDw5IPRTQuQ8YOTA8xBHqOOaJFIDATDGWZ0h6tJYxKDIfuaebeT7QBnhRejKne3RmcUbMcMUUzqZTbV8eHzj5PKrF58MWnvgb9H7m-HUJHcDWKpjsNXuk5U7rUZ-Wu2CM0r4wKZRAq5WbmPT-yzEMwGKaYjzGw/w432-h675/image_2022-12-21_143707366.png',
			src: 'https://summarycentral.blogspot.com/2022/12/a-short-history-of-nearly-everything.html',
		},
		{
			title: '25. EINSTEIN HIS LIFE AND UNIVERSE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjrk6fP7GFdamA3W4m7z61Zxw5KO2kTtWX6dzYiVAB6Srv2Hw_pEHvpSArX7V6fj5YXBS3gAppdaxwGljX6hEZuigvt3hTYn-YsqdUlbde64oFMlCqbTyPMREHY87diM54WhXf8hfEEoa7JJBLfuiDMmJIgat1exi22h1zxF-bIK3kdtJGwlzOa9iOSvQ/w553-h553/image_2022-12-21_151356233.png',
			src: 'https://summarycentral.blogspot.com/2022/12/einstein-his-life-and-universe.html',
		},
		{
			title: '26. LEONARDO DA VINCI: THE BIOGRAPHY',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj3jX-0GAfMFYS3BHBy_UqePul9MFUm1k1t1IMSURHAlQ7khkksvs2TO89HJmMF9wowTZkdTeYtaFKnvyeXNFha54u6sVhkjzb2NqKU5RAmkPtxLVi6REcWuBXI9IKay0rdosSrDfMreSPmb6SHJhaU6BY2F_vn6TBVUofCz_7mx4-33-XlwkSf44LAWQ/w494-h373/image_2022-12-21_183526671.png',
			src: 'https://summarycentral.blogspot.com/2022/12/leonardo-da-vinci-biography.html',
		},
		{
			title: '27. THE AUTOBIOGRAPHY OF A YOGI',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh236pcpRPahJcTjFcqflcYJE7Ru6waucz7o8BmVYycVCsbWKgHBLt6FYdF5ZhHkVB0T4r28KC2jZW7egKMUvKFzlTJ1qiLqpuLZuVuDpeyDQrAKWU89mh1cxMY24i5axd5Q0TVI8G-4LPDXJmdbohXYBDQN_uVk-y0dBHD6-xGisUpCtoyW87LBDqh3w/w486-h525/image_2022-12-21_184713888.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-autobiography-of-yogi.html',
		},
		{
			title: '28. BENJAMIN FRANKLIN: AN AMERICAN LIFE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhvwZvh86jaZ-co4ihN5moPwSgdP6SIZaGfcyBNCwNb9WYZB34HPh0k1YbWpI8qoycTQOJVnHFg8SC_LaGH2vJ_SAM-PWQUWiXazryk-PJbJKqmW2DtsJh95cwNhf5Hq0yvgkszhzH4prUAtrWEqjgqWCs8AT5ojYMeDD6EgQcS2P2zib0khNL4PisDfQ/w383-h427/image_2022-12-22_002531792.png',
			src: 'https://summarycentral.blogspot.com/2022/12/benjamin-franklin-american-life.html',
		},
		{
			title: '29. WHY WE SLEEP: UNLOCKING THE POWER OF SLEEP AND DREAMS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhn8IeKWIAFE_IjHE1-cBZi4cDBMFJh0OdBbbex2IkRyDIPZCnqxa6GTALMpLP_qc6OaIZZbHQecPQO9u_DUopOtJUHVW0gOj9SF6fVPJHqEMtIkJT4fcJpypQGe7L_5xzbeCobywMKxIg3i1AiMPft_ez6msa1XPuGlkrPm5pw1jX84ycROm_1g02fQA/w549-h411/image_2022-12-22_003227352.png',
			src: 'https://summarycentral.blogspot.com/2022/12/why-we-sleep-unlocking-power-of-sleep.html',
		},
		{
			title: '30. THE 5 AM CLUB',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjqFXo8r-xI-vdMKEpKhrLLqQc8KmgRjBTZLXhPEGefCbVDzxTEMjB7jtg2bnK5hdL4dhk5L-5b5EWe3So9ifiwAoNRx_HoHrrruAOkt-IStlHz7X2nAIKZ-JN5P6png_e9lODMvNabAuD1KHKlRUDHzs0epP1qY_j8REGlZcZLoX3BVUss5d-1wDi8-g/w606-h371/image_2022-12-22_003754560.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-5-am-club.html',
		},
		{
			title: '31. BUILT TO SERVE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh3ln1QwZlduaxDfpoXmdQjXzrnbne3gS56hRJDo9_JAKJS1AtRwwSE4XTPdDd9Iq_yWRr28NVkIj1fDv84EvGMpvNZsSojAovVJSZIgYSEq4creGwElYfboUQqoK5Fx1zfyNeuRTt_f94ffUvGSDDVN7jCjICHoy-s7oQzoehO9g96dJn0KD5CzhI1XQ/w566-h371/image_2022-12-23_001728680.png',
			src: 'https://summarycentral.blogspot.com/2022/12/built-to-serve.html',
		},
		{
			title: '32. THE GO-GIVER',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgI-h4PDoccGFUKq_rkwtr2zeOwqdp4nC6NHvNCd1S7LzyOOOPNEMYEXZ1PoIRD5kKt4LI_JvScDdz623WWXjs7t3n70gjHZXGSNDzs-9oCS951V6_q2w625xUGU1aubtsoOHAI6bWt-F4ZEbeI-rQqyIhPVH_1ES4lqB1KiKDNV1AhTWtKKfy__oIU-A/w595-h335/image_2022-12-23_002103109.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-go-giver.html',
		},
		{
			title: '33. MARCUS AURELIUS: MEDITATIONS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjg5Db7JRgZdcvcYNQRAu0ejm-b_S0vzPsfZpi9qPknFJwDXEtUQ64lIkvFYuOL6T50MotGyW6v6lDUuFJysabZFSeqSGSxA7QMJncFzSLJccRAIEaBj8zFPqYki9E9Y-HjNapny2Ezci9kFeE_bsP3NNL3Pcjg8n6TwlXPYRRXuxJxiJ3gFyGq_qSk-g/w445-h445/image_2022-12-23_002525818.png',
			src: 'https://summarycentral.blogspot.com/2022/12/marcus-aurelius-meditations.html',
		},
		{
			title: '34. LIVES OF THE STOICS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjGhv4yRj4wKPcj97eVpz8nTtnbDW_4iRWy9QGZ4rrH-X2mQLAKMCuJa7YD3wMv9FLNYC7zAG5PqQ2oRvAPRP_9RvRiqVXjXk7zPHMMh4Hv0azLGi646eEfFFiwW2w37Abn3lzmpk7H9ShlxZhUnryOdo6D7OhoAgS-evaENP2kYXVeGcvFc6VqxqDv6Q/w475-h423/image_2022-12-23_003017119.png',
			src: 'https://summarycentral.blogspot.com/2022/12/lives-of-stoics.html',
		},
		{
			title: '35. STILLNESS IS THE KEY: AN ANCIENT STRATEGY FOR MODERN LIFE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhUNJf1q3GIGyQo64zqZUZ5aU5r_euwCkZ4a-5vv_ik3HWLWmq28MCSXKQMSQz5BzMG5wsenM_H1CbspG87aivGmiaGPBiYnyKl7Mnu2UywZfsQTwRBqZqssNseZJ6f0yrJDxhUgBkHnCP-bwhUPWweua64FAgUW7VBCMF4tbRLhcRMOdsQSODO1guVqg/w508-h404/image_2022-12-23_004301870.png',
			src: 'https://summarycentral.blogspot.com/2022/12/stillness-is-key-ancient-strategy-for.html',
		},
		{
			title: '36. EGO IS THE ENEMY',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjwbtly8DjHXWHfHUvIXb4xOzqSYPPbweWAJ4cRHXQpg7Cq0-IQDmJkLDuPVnNPRqfVF0LzbMgz8dlS9jQHBQWAparVAKo9tKKBvRS5tztD_hatb4ZYwMoEPsJ-BdVOia_QKIttVEKtLcx9SwLxrSocNHOqLMYxwZPFp9VOhuo-Zer69ZtveDVZflTjEQ/w528-h528/image_2022-12-23_005254255.png',
			src: 'https://summarycentral.blogspot.com/2022/12/ego-is-enemy.html',
		},
		{
			title: '37. THE DIP: A LITTLE BOOK THAT TEACHES YOU WHEN TO QUIT',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiGPr1bkCgupR_HyKvsJlJb9YJzkhDa-Z30bj_PrdkJLu6UTxQn17YHkJvh2e-WfjvWFIpl98O6-1bxc-wapymUYmx9LlOy2o7lUyd5Igw9A64sd0dkhMPDj4qI4kPaBfBYaaP5l8Z2CCcDsU1XQ-J0b42pQ8Liu6Fp-kiMA3BtD2b0hSt8oOBLXgmtFw/w487-h452/image_2022-12-23_010619161.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-dip.html',
		},
		{
			title: '38. LIMITLESS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj5r3Ej8cEyZJAK7LdqR4Z1jpSJjBrKy2MJZoIPdOMiI6vDv6PsRKwrq_5RRZ6HqOR3Aqk7oeJxW--wlnD78I1XBb71GKk8wSzPqO7U-z6GdimYOcyAzYFtbIXcpBMOITTyGb8_o8r3ybkC8Hk5FUlbIl0p70V9DXDCp5UzC0gI9TVdelj9PtaAODEl2Q/w486-h648/image_2022-12-23_011138963.png',
			src: 'https://summarycentral.blogspot.com/2022/12/limitless.html',
		},
		{
			title: '39. THE 48 LAWS OF POWER',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj1DdOjXtWZlsLpLgtedkj8VciTBR_5EDTGT2NEV4ETmXEIjP_45atfbYTpuncRly8LjjgwXgUpjIQRDRcj7Gap06cQHlR6sIlJe9T5PjkWnlktBq_7H1mEcXvNcyw9bGrX2v61dQgtv4aeWvxnswskBvvZWn5d0isyvREnil7KTbvSlsdfGPQ6XNDwyw/w632-h399/image_2022-12-23_011919853.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-48-laws-of-power.html',
		},
		{
			title: '40. THE RATIONAL OPTIMIST',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh5v8hfUD46xWiRFa5WS0WV9jvbl7zJBUWLYogrbUeKma4WoPcsy0Og3ee-M7uhx0vbqEqY0OWu1CPkfo0P9x-Kth9CvdLrktzmBvudvcXm8pgByt_amQSpShwc9sZB1qzzY26YE67wC6Q6ku_FonqqZ5cfinc___pWK6orLYWcQn7nItOGVPkqT91cGw/w487-h544/image_2022-12-23_013222305.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-rational-optimist.html',
		},
		{
			title: '41. BEYOND ORDER',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjKZk8FPb3hePeG26Ig5Y-92DY6P3phHGzr2Od5HyrmpMhoLSpvfKWwbASWhc--x35Ex8HQMeJvu5WmSQ3zpfKOkxWxN_1oR3Br9NymjV6SCG3VVeJ8raBfbp-TcIptR8yzeNq-wlpzZgP4nxppiJts1q3SAo9OBA11cc5tsAVMNpaAwL57YNJL6rN8jQ/w570-h321/image_2022-12-23_112904517.png',
			src: 'https://summarycentral.blogspot.com/2022/12/beyond-order.html',
		},
		{
			title: '42. GRIT: THE POWER OF PASSION AND PERSEVERANCE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi1fSWTf8YQi6oChmvMf0gru5CR-GgFDDmMPd4rentfIdSeoAIkYm_CDlreN2oX6jCKZOy2FUgATmpvUvhXf7349lMI56Hfsp3Wgy-osStNo_3KSLHASVyi8X59nh8H0pR-d7ZTEKKauBIJfGv4N1aMQDN6CK3vBxEpcRzwj3vroUoRyOP7Xgr8mmc66g/w494-h494/image_2022-12-23_115813954.png',
			src: 'https://summarycentral.blogspot.com/2022/12/grit-power-of-passion-and-perseverance.html',
		},
		{
			title: '43. WHO MOVED MY CHEESE?',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi9jNznjHH9gHm1MlJrCBprMsKzAauoiNB43dtNIYlvk_aXE-8qxQtNLyPRcJyUjXldhYbT9lzfcLPtMjIXldILcfiEmu5GddAFQtRiCJbvyLYqunmA5sHDUsmSIv-ahHPPbZwR5IWd6SqqIC4udlFWyRwMLVrRusyta4zFl2C9LkXu-lyCsFHPwQx36Q/w582-h387/image_2022-12-23_132309818.png',
			src: 'https://summarycentral.blogspot.com/2022/12/who-moved-my-cheese.html',
		},
		{
			title: '44. TALK LIKE TED',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhb0ptSlbcCyHGLgjH3aTwW-Kl4DwccyDwSNtbR2P15hhHcWfAz9dRZbGwq0iCLEDFEQ7UNkMsjXLPT30kFNjLAuMriVfGGzvgOrjAlN_pMvL343LzKI2l2ov808d1lkPtd74-7oxAvdpdGU_GLW0QFcIwN8TqmnrudrgGxKHW9AdlBENcTysyKfx9uFQ/w539-h539/image_2022-12-23_132707532.png',
			src: 'https://summarycentral.blogspot.com/2022/12/talk-like-ted.html',
		},
		{
			title: '45. CRIME AND PUNISHMENT ',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhK7Rsn3aDCvJBn9lJoC3vuR2vxosRidBR74TaXn3vcnEJRUBnsKnBLCqeNcjBDrljH1trm3BBAEeiTeayKY-4hssy6LUndVja95_6eVqetKIlsqzZqLp42B24Xf02wAQHV4_QkNDIeRvC-mu8UU-rBzSUVC0Z-UH6mme0Ap22kHi3ZCJXEaQRNV6P_SA/w387-h429/image_2022-12-23_133321761.png',
			src: 'https://summarycentral.blogspot.com/2022/12/crime-and-punishment.html',
		},
		{
			title: '46. EVERYTHING IS F*CKED',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiAFJItptMk0mAyThHuXLu-wcj9p9TpE5zYyMOhJlXtdOAbnQyuihCr1arqmV5E64fqKh3DbifFlKHBx-DhgGaicuOFxoyMvvRVC9npOCnUyeEouNHME0aYABj69trKZhS1uvKf5UOOQQq8Lr4S3HmEGVdYuEhf889sw4EJm6rPLZbFznLt8fqmge1PpQ/w451-h495/image_2022-12-23_142304299.png',
			src: 'https://summarycentral.blogspot.com/2022/12/everything-is-fcked.html',
		},
		{
			title: '47. MEASURE WHAT MATTERS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEikB_CTO9K3XfZHu4uP6VEQAPltN_0tACiJYQYFViHoOi8Ky_u41bXBiOwrioJPFRjQUDJ8AikthbC9y0G0XWe5UuHZIwQyoGXK762Iv4lggzCIZ6UVJyTRlejsDoYQQwnqg2jz13220s0mfQ88Jich6DiCOJLKFUVpavLvyl6IrUQuSBGHNLB3LfDx-A/w572-h381/image_2022-12-23_144605122.png',
			src: 'https://summarycentral.blogspot.com/2022/12/measure-what-matters.html',
		},
		{
			title: '48. THE EVERYTHING STORE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgXFDmpe9cHf12moAsvANr19jWI43Cf1kcPTQpmo_iiA_zcc700kw0ak0SuOnrM2LkLLChfg5j1EM-I4ytQnxp0BNBW-cFCGAbPkhKBKf8NxnhMYSiy-OTd_L2kGwAyVp2yv9sJTWXgbmgl63tAgBVMHGbh79toalZtF4GWoZDsYfrQbjbfsmEy3da78A/w575-h431/image_2022-12-23_165210963.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-everything-store.html',
		},
		{
			title: '49. THE LAWS OF HUMAN NATURE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh3ICjo7k-diTuphjzCkyi5JNkUqLPf8oloOFNfaAw3smO6JIjEj3m4pCrislYGh9Vcqcnx0rttySQEFtEEdolKj47HVuAnGOzKc7tgovicqFH926_xKC745_qU_TTGY_y5cj9iuhQbXk4jPzY-2IMMiJA3FZCVbju4XcKDWAkBBDjqGIFCLWJxDVoItA/w537-h384/image_2022-12-23_170622863.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-laws-of-human-nature.html',
		},
		{
			title: '50. THE COMPOUND EFFECT',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgHB1Tny4afQkGNehT8QT5rA2_6Qn0FGIMkpQZj-RWrBHZkaQRPkybN52UysX0E2XPjT90ndU7iXfBaXEkkfIcL3ndAdWsA99MCdgDNBs8DJoT1si7FdReLWrPc1XsaVrG_FoYwGDVmBApIhlT8zIrsXNvgbNrh1jJ4WYQ-kQmx-o_V44G0nmD1iRuEFQ/w546-h546/image_2022-12-23_171634981.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-compound-effect.html',
		},
		{
			title: '51. THE RICHEST MAN IN BABYLON',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEixqwZPVHM2AVa1A__g0Bv16d9z523P9aw8jpqjEwpYB_o2rxOK6FP3EKee7HY_fe86mk02Y0Zp7QGZe-DC3MHPf2mmZ-mixGUU1c6SXL4_OGe2bDeV_9pJ5uhHD6W2r-8JmHX682oGT81eqBVwVv2SGVhTy4hKUs3kfWnu88p3aFFwoOZnzDAiUoHpqw/w376-h467/image_2022-12-24_161916834.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-richest-man-in-babylon.html',
		},
		{
			title: '52. POWER OF YOUR SUBCONSCIOUS MIND',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgTW_3ZMvawDfcTnntoewzUhMouSbQ-eQ2izbTTcZlclAHMOnHD9brmk9ZnjTk_Ur-6zEtkOsURrPyFJcY3k2XHLzpSeNxKhucPrhC4UgOmR749korKdDblI7vItlsu3hk_I3xjnEisNKK4DqnVDzeyrxRSyxN0R68wOOoYkV5oOea7QUJbed_KgVbZrw/w543-h543/image_2022-12-24_162442862.png',
			src: 'https://summarycentral.blogspot.com/2022/12/power-of-your-subconscious-mind.html',
		},
		{
			title: '53. IKIGAI: THE JAPANESE SECRET TO A LONG AND HAPPY LIFE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhrdbuJPRWGXXrqTtKwfN-om243JYO8OVhaIrcSHlqlSqiJyoq82viMxlcNb-v2-PI_FUCXIvvul3JEWleNOujMhpg2s0R-dIQGywUavBF78JT4HA9vR0qfMs3odvl6O5ppyRfcl-OxblVhfrT1x9rxuiqrKLOJYF7BtWGujTZ5OTJV6DMyYGLUbd2YeA/w404-h404/image_2022-12-29_151758133.png',
			src: 'https://summarycentral.blogspot.com/2022/12/ikigai-japanese-secret-to-long-and.html',
		},
		{
			title: '54. KAFKA ON THE SHORE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhFxjA2Y4af4HilT4SHtaJMO0MBWeBPgrcun053gCWhD85hlk2JfI7gfcvjmVqK6vKbjWR4yneMCSl-ZjzLf7BNKd3ZLetlRhL83nEuDwfUPsdJJSDviXi4hoUPwMnCyyaLr37Q3DEbyj9KjC3YOkJdLBmfT-OFRFInGgxkaJgfLImrhz5mnEk4teH14Q/w415-h517/image_2022-12-24_170648014.png',
			src: 'https://summarycentral.blogspot.com/2022/12/kafka-on-shore.html',
		},
		{
			title: '55. EDUCATED',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjokhRkuYIaUvQZoF6XpwnyJnoHGU8DG3bqEraNZtZNaXA6Uo4ScVyUtP0vCHIQ5W76_54vGCaVU_Qj58g43uqrYjS9kE0t66ZIWqRRLBcoGcpHpaSfiHvFYhcT0Xuet11m7v8Uq-c8v1FyuyreWYxepiK8vjAiOO94HaUSrpFamrMg17R3onHWLbBv5w/w555-h343/image_2022-12-24_181306506.png',
			src: 'https://summarycentral.blogspot.com/2022/12/educated.html',
		},
		{
			title: '56. STEPHEN HAWKING: A BRIEF HISTORY OF TIME',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgwXXyQI2lc_oPmTnC9BVGuAAHUL-Ab5GLXKUuO-30M-YnSR0Cfc-I2ijOFAT_vs5PDkiLRu71iLpnZ9ucWTCT6n0tbGqfZDCJIf5jv8bya7FEYkHk63pv2n06P4RB10bi9fWhxfqXzOkJK2Qjb61EGiGgpIKVLqZVKZXplzUlde5GnkwhamunBU7PQyg/w351-h394/image_2022-12-24_182214453.png',
			src: 'https://summarycentral.blogspot.com/2022/12/stephen-hawking-brief-history-of-time.html',
		},
		{
			title: '57. THE SUBTLE ART OF NOT GIVING A F*CK',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgbrmF5QrU5jlpdeisCftDlB1tH9oVTy9M0-4T8A9IciCl2qU-GzPrUW_btvfVnyQXflxsC7fsRzE-dei9f2Ecqkj5BzF_sIRQVYxfYCYZHzTSM0k-tbCzpXiDm8aquWylkderDAVLwnUuMfoDt8MPc6wLhyGeX1y9WoRFjMLN9o6SrQy0psOL1JgG2NQ/w617-h347/image_2022-12-24_183513650.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-subtle-art-of-not-giving-fck.html',
		},
		{
			title: '58. BEYOND GOOD AND EVIL',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhti7q8xXAbnnFaQCEwjk0N5tujcc52spXuYBRfFxApmm-2AO87kvVnQYo5SuCrZIFzt3koU-ZkF1NgafHr87cxL6hazK6j4ZamM7Sm7SlRvv_O7hXy9chwKuIR_NJoAvbZdmeW52iFoIgNVtmcN9l5MPN_6-_HY_fxU9E1Tt3Nzytu38LhOs5FB1F9zw/w447-h447/image_2022-12-24_185403804.png',
			src: 'https://summarycentral.blogspot.com/2022/12/beyond-good-and-evil.html',
		},
		{
			title: '59. THE MILLIONAIRE FASTLANE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg2snRUc53Fga99QP91Cwec3bDkflrXxoab5z54FO95Ry4WHZcpGFJi6u1V8TTlhvCGsRPj2ZT1bxcuioo9-ewreEKPMEiLwB2AfiP69HSkM6p9UeOm53_RVGgyRo6RsAKRGXJfLZFe3LL3bWH3XLXtSAVtH4-hj5dn2HmvIh_gNNA2hrfuAVha3rsr4g/w489-h465/image_2022-12-24_190810894.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-millionaire-fastlane.html',
		},
		{
			title: '60. THE LEAN STARTUP',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEge6tMNarHpeU5DduZFpZPZPov_K5stBJCY2aM2A9wMYzF9rJDMiCvqAalz23xzGz8GliBkzYsxUyia9zYrb18x8c84oTRz69zSbXiZlU06nxRvz7x6nu6iW-oqhp_vnDeMoCO4qsluNs5z12YqsY1ziAFbP8pJkzoasEKimDTEfxZ3tY1lxecH3E4EOA/w592-h333/image_2022-12-26_171112013.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-lean-startup.html',
		},
		{
			title: '61. ELON MUSK: HOW THE BILLIONAIRE CEO OF SPACEX AND TESLA IS SHAPING OUR FUTURE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/a/AVvXsEgi3M4G6NyqMqOfPxgBGvGiDnvB9K2oQygmoHcVWSX8xGsdXYFgaXRCzlbZme3bd_6ITu5CWpjSv77kZDWfo_06zm6f2dD6C0p1OPuEuIkAvrqPjqMZ5H5NDYTQ76zMqQsrt6O8zh9vFaVcQa8MvSOnhWCOiNzGmPOhNJBwhri1Zf-Wnn6YA3pdTPE4NA=w432-h510',
			src: 'https://summarycentral.blogspot.com/2022/12/elon-musk-how-billionaire-ceo-of-spacex.html',
		},
		{
			title: '62. TESLA: INVENTOR OF THE ELECTRICAL AGE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhOYvDzaH56Ma62evgGoUEVrLViqb0DPm21IklMY8BPJQefvjCNsSbBNgQ_k6677mZsYIoOnO-33puPsCjSJDsAEIJ-gmgmPoNb-hwqnnIbj3jcKZhhdks0SKTpUnYhcevslpZdfW8c_gxuec1wivOWTAkVMZ1P8cNpM15CAq2BeZBl0fBAUSWtl147PA/w393-h594/image_2022-12-26_173459542.png',
			src: 'https://summarycentral.blogspot.com/2022/12/tesla-inventor-of-electrical-age.html',
		},
		{
			title: '63. HOW TO WIN FRIENDS AND INFLUENCE PEOPLE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjQQWPTtocSKk_PH5ltQhG516KH7mKJ9eXXtLsyGK7jb2q9yffg76hGHobEBfs_tk401VZlJSYQpXhpCyW5SThok0PFNyIZDTnsoA1RK15FCQvfKWFX5R1P0ikJxOF_QgeIJM5Q6ZHAguQm08srZpFuIOegub2ojjwRFfs8zmkHO-hT2hEYC2dF-PVqRw/w415-h629/image_2022-12-26_175000745.png',
			src: 'https://summarycentral.blogspot.com/2022/12/how-to-win-friends-and-influence-people.html',
		},
		{
			title: '64. THE BLACK SWAN',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiNHuHVBLxeB6JBWxP5Ib31vCEqTXY5ZEyWJadFgqAWtjtA4ThmLF-YYFGMYtGheZMU-O9UYpCrawR9jcTI8AfB7I5_cTNSmOOdp1mT35kulGegS4EhnkE6aF-mukLhxHrWfD_NZ8ANXJh5C8N84W9QcxknO-6hgHanlqoyaXSY0VFFXtKK-s0PdbvjUQ/w393-h599/image_2022-12-26_180014007.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-black-swan.html',
		},
		{
			title: '65. THE STORY OF PHILOSOPHY',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgvw0P5Xw6on56iFwAvZML0TxrcxLxrprFAs8qgW5OSFuYeSzQhUNJ5_2P-r9KxUEdJbBhfFPvmen_qub--UFvMU-gbgmwRjlRNhlQmzT4u2H03_xV7nfRFuXchaFu2z-BIHQrHNJwyk_-L2JZ8KcLPVVitXxmkY9JTPpBRiZ04isJ27KMjw7d5H3-uMw/w375-h510/image_2022-12-26_181429979.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-story-of-philosophy.html',
		},
		{
			title: '66. PRINCIPLES',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgYs1Dy4qlNhJYgsVXua7iYGP_iu1nwCk04_uMTyZbI0mMkAlREpjdGEAPaJDvMg1rilMcpHDlwvanrvXbKad-eOJihYsLsjCo9CzcNfl-fCNO5v5E5TfitMTKMKKO950mH7-NifjMKfP8uE5XkRO9H-dIdIwfQxMUo91jYTox473oiDSyPwhGc48zevw/w562-h422/image_2022-12-26_183306062.png',
			src: 'https://summarycentral.blogspot.com/2022/12/principles.html',
		},
		{
			title: '67. THE HARD THING ABOUT HARD THINGS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiruboFo6dUO8qD_hDmtPEpqzzAmiHCq_aBiKv3FL3YzlGqZWg2YIadRaL1fnOfTVtUe061CjXZntfGOnREJxN-wzE64CZKciiucMeZ_8ABLi1gSh995vTZPh_MNcfb35auLgqSApUcMFlbOPqywl2NX6a8BIlayNNe3492dTAfQRX0ox6-1AaNwoVI5Q/w590-h332/image_2022-12-26_185536237.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-hard-thing-about-hard-things.html',
		},
		{
			title: '68. NEVER SPLIT THE DIFFERENCE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg7gE7tq37i3TDPx70SFORSr9KSPFhvswKcQB7jFB1wkUG_aZObCZ-ORU_3SMALazU_ajjs0YkPAzYjWziMQO3Bk-8P_EW4Ipf4FMQTDq8MB5kmxe_y16Gyjo-Otv2T_H_JPW6Wt8DO1mCSktuJYepapRgx5MO4Gkr8sqCCWUZ1GGRgfuFQirlo4VfShw/w440-h587/image_2022-12-26_194926873.png',
			src: 'https://summarycentral.blogspot.com/2022/12/never-split-difference.html',
		},
		{
			title: '69. THE ART OF WAR',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEisQZ6dPRtkkTXcLjLC8vs1Fj8Rh-7hl0LCSd6KqIs_0ReakjatPZr8iIh-W9HOW6cHtnHH6TjRr-VmHDAEINo49R5BYGBTfu5-D8BTkIyw1dVlIz9XNQGb95zhSDmmoEDgZoBOpDLCelJ4dRTHGxKWB-9HATUMGuXWw-drdpb0n-d8Iz-S0gyueWQ2-w/w387-h445/image_2022-12-26_201420116.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-art-of-war.html',
		},
		{
			title: '70. THINKING FAST AND SLOW',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjAlaSqTzgUlK0g91CtsUQXugNZQKg7PrLNXSW_GYW2Z-IvVzfOsKqk-tX_oSEUJBCITt6BF_-bpq5nubqMK0lXJCC0x8S6toYhqMTdM6EoyEn-qzc7PmxPN-7_Ird0gGY_Ojw31VEuT5As353DqIM97YsXqP8mJSZr8pphSSnF2KyPSuUVp0gr8LRGug/w597-h597/image_2022-12-26_202619242.png',
			src: 'https://summarycentral.blogspot.com/2022/12/thinking-fast-and-slow.html',
		},
		{
			title: '71. FOOLED BY RANDOMNESS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhJUACpZUpI36RVCTQKw4Y6VoPMEz-c4dKu_n0jAA4KggQh0RO2wNfwhoTN46GxmRThpQ0r19ptW7G1MeAOM2Ll8kDSPJof89V79VIQ_Ilcp7WU7fddzH5ByYNentAYMwAAGWaAn4RIQKrP3plQSUrdVU6WA3d1zObiEXVHlUMo7ODqTNTDjrnyRe6CYA/w388-h524/image_2022-12-28_001100101.png',
			src: 'https://summarycentral.blogspot.com/2022/12/fooled-by-randomness.html',
		},
		{
			title: '72. LEADERS EAT LAST ',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgSIMcphNfm9aWcc-IIgz-kygEtDHDn0hVqn83eTKqz-0RObWYxY-n8gEpvib6K-pOWX20EwJpKpBVFHQKfL-EpXVae199e-LNa5l1EHz-nxxsSRVgbI3D7cQcSncsx0u4SMQM_kWf_oEGOQmhUt4yz4iBfgFJ0JM1A6RCLOuUQx2lzgIpGcxJ4QzAY2A/w389-h467/image_2022-12-28_001406318.png',
			src: 'https://summarycentral.blogspot.com/2022/12/leaders-eat-last.html',
		},
		{
			title: '73. OUTLIERS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjncJ0QRj-efrz6RB3eybLZ7dT0CECnfa51d1cdtHYYYj2BHbR8_FxUraqeqrat31RFdT6RcmrKaLEUtXVz8exVwFwhz5ZMMz6K8jC_93LuQWf6tFjDqMd8XA3jI-dnRXNwONQ3mnzmUZ_88-2TdPEFWdy6REyZSTeIzeGiDBOxa38zjCpgY6t-ZrdCxg/w455-h344/image_2022-12-28_001958874.png',
			src: 'https://summarycentral.blogspot.com/2022/12/outliers.html',
		},
		{
			title: '74. HOW TO CHANGE YOUR MIND',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi5G47bNdkSntOAau5ExvJzDvQAODzTxsEUmZo5HPsDOcitvqbXMwCvV5GqasMMInHoPBqz20-4aRxOkicsxn_Lo95CQyCJiSKnvc9uggT5BDDNVsK5TkmDPCqz9pCyU0KnIKC_G5gw-WcLQa6-HfvtmFp0TzqbpW6VVVCHNl8UPn_T5tQy-hvvq9xbaw/w438-h459/image_2022-12-28_002450437.png',
			src: 'https://summarycentral.blogspot.com/2022/12/how-to-change-your-mind.html',
		},
		{
			title: '75. WHEN BREATH BECOMES AIR',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgYFB7VYYqSLiH27Hkyc0OXK6HEts-eRDcJs-DDCtX-lP0h162bzFO-U4uQCk1EsEHWiJmqyNSb3KTkXoNvIDtG5wA944kloyK15WVX_tHatFmLWAzwuv_cNPsK6dJ9jgp0tJx8A8NfHrj0OupjCRTzof6_x3ARvbleAwzGhu2D-ZGWaj6aGHSgwlE8EA/w343-h426/image_2022-12-28_003042356.png',
			src: 'https://summarycentral.blogspot.com/2022/12/when-breath-becomes-air.html',
		},
		{
			title: '76. REWORK: CHANGE THE WAY YOU WORK FOREVER',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiYAajd-DkGb41RC3Rrj2KLU5-yJogjv-FY3-RHkEL-bYmpiU6IiIOewkc3TVt6bcEk5OZ3OtepcIyIqqBrWrS51cZFysjEK--PE7Uidf4UQlqx23fY0VQIMj1xPYsEx9cZmLmEsuvfV57hl5gh6ZiExNVsRC-JnimHXcDia_KYn1QMuQpBxsqtsPifzg/w375-h409/image_2022-12-28_003356823.png',
			src: 'https://summarycentral.blogspot.com/2022/12/rework-change-way-you-work-forever.html',
		},
		{
			title: '77. MONEY: MASTER THE GAME',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgRinBo6lMvjLVaVhFnTPeihfX8t3hFIFDXpAqjjBpGVBHMyOHfnvjQ-oks7vBMoBF-GuHQtSxTpCM9tGkPApCibr5Z32U2hbveDKr8Mg2IvD7Wo_6-PGUbNt58-tAfc1xtOKQahpUol-b808_GGVc4NlOnYZFwqgyHGn7SstvmeQ3gggHHBPYrFPOvtA/w353-h554/image_2022-12-28_004342319.png',
			src: 'https://summarycentral.blogspot.com/2022/12/money-master-game.html',
		},
		{
			title: '78. THE 4-HOUR WORKWEEK',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi0qL_N6_rKdmdjL2nla5hiAm48ISbkqFAgjNAHm6eoCkKXq1RhWa5ndAFEzPr7wU1TaL04FbxkVhizV540va0SKQ8hcOjiyWjwH5edCytdbjbPmG2aY0dnjuwefsVx0sQy9E7BGdQt0x7lIRqFYm4dBVgWqmO84A9yI6RlVvXAJv1CY82P_fhIwPEsJQ/w546-h335/image_2022-12-28_004931490.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-4-hour-workweek.html',
		},
		{
			title: '79. ALL MARKETERS TELL STORIES',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhXs9yaPnQig4rDaCRx9rmlzRBllWSbNEanJElQyfOHLhGJvSthPeKHIKatmtqo2XJb0zWoSCU927DXL-FdItQgmFjYxFbSMl3lhnTXaieN46DhxEfASzh443Mxz8J3wzATJDpFzw71YpeWEd_1uoKqyvfm70BTgIwYI7abkOfkaHQUXGl2N1nEi-3ZUg/w465-h525/image_2022-12-28_005804219.png',
			src: 'https://summarycentral.blogspot.com/2022/12/all-marketers-tell-stories.html',
		},
		{
			title: '80. INFLUENCE: THE PSYCHOLOGY OF PERSUASION',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjzg5aIgFqR7H4kJI4Ne5nA6fAgq22zf3tTKbBbRDfTLGorCetGMltPMWhYYH_KNTsU9EQZcFlPPj8vkFRvZKi_aft8v2QcxRBTkzggx91K8noKR00R-IhI14nuZ3-5aaCEvqysuaOk2iTcQPGYlRkbmasaTwCROZPCBu_nG_89LIoo3Suw6X8R7pELTA/w288-h363/image_2022-12-28_010741945.png',
			src: 'https://summarycentral.blogspot.com/2022/12/influence-psychology-of-persuasion.html',
		},
		{
			title: '81. REALITY IS NOT WHAT IT SEEMS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgZya9Eq68x-8pb_oSdquhU8Srz9YreX_PnWiW5RIXO0Zgs_LbFkn5DXZme_OKYtO3Hz_9y5KH-ZPDJolx4XwbQYa7zbd8cORM1DGzGHx2_JJhkjvSiakBOuAwjpnRpP2Xmue6ry4jrTZJvy5hElAAb-1Ewm9JlyJDQhVO7tl7NMhOr4VpQYoBjoVtqkw/w412-h412/image_2022-12-28_112534199.png',
			src: 'https://summarycentral.blogspot.com/2022/12/reality-is-not-what-it-seems.html',
		},
		{
			title: '82. THE MONK WHO SOLD HIS FERRARI',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgmS9f9MptHqf2lKcd8_gUZ7U_SoRlPErLOyELRk3CesuT8dBueI0NFlb-SdHHLYsCAZJnxdHpnOxtGn0VurfaEhYxQuPmrLOoY5mgXApuufbiIbV68zwX7jFZ-eoQx8zHTP2Tsbu5Dg3IYvCvbTgAy0gZtwHp-RPUEs5JR3rTxuYHq9zD28YrGL9Bi7g/w414-h489/image_2022-12-28_113239705.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-monk-who-sold-his-ferrari.html',
		},
		{
			title: '83. SKIN IN THE GAME',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhAwi27uZRP9sM5N6cKAxsPJWVXRFhV7GZY6IfTYLTYulrA9vFggZK2GqQuUKKZiGB_Y2HQW4TLb4i4QZBwi0IKdqrx1Ninl0sWket-jiIHowKueXRhQsEP-nHr03dt04Ar17OOKbgfr1rRnbWaKTic31y41xGZ8-P_zaQunkHunTVwGOgeBpiENnPdNQ/w452-h452/image_2022-12-28_114805865.png',
			src: 'https://summarycentral.blogspot.com/2022/12/skin-in-game.html',
		},
		{
			title: '84. BLINK: THE POWER OF THINKING WITHOUT THINKING',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj_NJOguuIrmRXRFY99TwQ5IA3Yfn-SwX5tolyD5yH5rvzrhGcLhIDZmFazbqXMbmwWDHEb7ycxe6awwyEg5jp06uWhp7tZh-5MLnKRrr5wFKfvBIP1lHmIHT5XTcfOBA1E9Hjwogrc1_42izFCQp6BdvOylL6Hbn4rVcWS_rO_xlD8g3jmRnJeTpgCbg/w387-h440/image_2022-12-28_131241464.png',
			src: 'https://summarycentral.blogspot.com/2022/12/blink-power-of-thinking-without-thinking.html',
		},
		{
			title: '85. THE GREAT GATSBY',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjHRYqbY8nwPzdI4Jsm4hUOskHfYDvyjhlGZJhd3LakzmVCqCbyxdzdD-hwum1gk6kx6JkN2N1j4RAqDZsG_1bnkVKfYicbRuhBByI8yn4MYDRX3cM0Z4CtFLiTM-mP6zuqBVSnYEjpv9lqY60u5jZVZy4rivOfSaf08h5VPUOlat2x8vxA-Cfm7GohEg/w408-h399/image_2022-12-28_132452357.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-great-gatsby.html',
		},
		{
			title: '86. TUESDAYS WITH MORRIE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEizFZP7lLbXOrjNecjQFq87ldwnocXT7FIxjPJp4xCZxP7fHAFsehGiGhUDju6bGIi49Od38heylNYmPXaswh1int4OOdUNoXXz5I0WlwSAx9x3xGxlibu1FWURjM_lJ8WXTAmLnYiVfr5TRqzk_P_cXXDqE3wPJlF60xBXRGgN0Jxj_gD2JGzeGBtbsg/w452-h474/image_2022-12-28_133214841.png',
			src: 'https://summarycentral.blogspot.com/2022/12/tuesdays-with-morrie.html',
		},
		{
			title: '87. THE DAILY STOIC: 366 MEDITATIONS ON WISDOM, PERSEVERANCE AND THE ART OF LIVING',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiV-79EyPliFTGkjLXYDCh0PNq9w9am-zlMCXnjonYhdsuA5v_a6IheiOtpU_OxSBCcP-SaVlT-bmGHDxozKxWsQZnb0N1D5YghhY4KH6PXktDcG-2JBvjwLR5LE599J-nMDbeleDCyFdqgYc2DZdf6tVBNAs4Oivtpqjawakrrl1UXHGGPNHGry-RLbQ/w337-h521/image_2022-12-28_134947087.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-daily-stoic-366-meditations-on.html',
		},
		{
			title: '88. SIDDHARTHA',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg2zKvZOcT5xmOwbs6I0R-ELryFxKxIy75LD40wgVey1rUEJQKZanB9FNP4UAJwOKrM5c4uZ90Bpc93j28oWrMnqNwh_7PQv1XEw6kWJr2VELmnEyGJ1ocE9CPBKIpo2ltJubuh72ZkuFa2XKFXWMwhKkd1xgvvvNHL6Db9yQR6IYpOJ-sigD9TNIeLYg/w431-h523/image_2022-12-28_145712126.png',
			src: 'https://summarycentral.blogspot.com/2022/12/siddhartha.html',
		},
		{
			title: '89. DIGITAL MINIMALISM',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhGyFKHACbPUR5KcqywOjxcHYsDY47aTMg7N3V-r7cS2bR5Akue-O39v6tXouDAywbjJuSy3QY2_c7wuylByT5FU6ewFlfLKCxlC9VK9ErJTJYymYq3cl8h78IaZeSEaFHN848jm_Gv5cSvoA9Zj5A0UuPIfLFs5hUlXNlzpA2B5jBA8D1-fKDU9sUZXw/w564-h375/image_2022-12-28_150833278.png',
			src: 'https://summarycentral.blogspot.com/2022/12/digital-minimalism.html',
		},
		{
			title: '90. THE THIRD DOOR',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhfYTfXCtj4l97djdnB0ihmeKVZs2-gE9NBiNYXaV90Mh4nHQ5vsfR4FhfoqqT7kKR4r8uK6_3WfxflrE0WgITbFgw5SL8vN-6yPxtw1BFqlm4qqRp3k4n5_SC93BGgSSpr6Xj7TrtVppqBYsRgn18_Awzb08E7T7yPrTpzcx49P1LmnbZh7asZYaAlvg/w515-h343/image_2022-12-28_153227008.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-third-door.html',
		},
		{
			title: '91. INDISTRACTABLE',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEib369ZWPpjuyHfrM3IOKQTbR7pQqryk3W3HDEXkDMHb0MT_xu6QF7mIuXbLfZdDl2b4cucLcY1Re4cuVJHg4vw5MeLKOyW4orq3N4ReKAjONkHKiUC7d4xwFNF-Lmbk5zhy9u8MaJ7R2NIJAu9h6p2ho27SjSG2S9HSFlfrV5VsA3zIRVrBsUiAQGCUw/w447-h432/image_2022-12-29_152510591.png',
			src: 'https://summarycentral.blogspot.com/2022/12/indistractable.html',
		},
		{
			title: '92. HIGH PERFORMANCE HABITS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjTK8d8mI-32o3CUAblS9RQ5ggdIRwSmOEpnFXTo_JMEBCFFZF2DkWf_oIHiQ5qT7XAZ_qJcz5FtyDcN7HM2SgGLzB0teJcFuoXVyC9OrIaIuUxlwUUReRRKJd9EChM7LEB3fJL_5SDKZsRmLgwLHrgIlblwt2Q-bME4ulHAjaRYCynzL2hIyl7gKCJJQ/w441-h441/image_2022-12-29_153659880.png',
			src: 'https://summarycentral.blogspot.com/2022/12/high-performance-habits.html',
		},
		{
			title: '93. THE WAR OF ART',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiM5-nV3-JWdH7NE2MjLKJ-5O1duie9_XF8QhbsdhqBITnUiCPm7osAOt9LXi3zIojFT40GDcQ1xnhhaZlrriJI7QDGJ3KBLP_IJmKjsxozS_G5XfzhsXifOXiYhhGWoRF-ia1vVEYowZ8hUXycEEueiDveavvAB3q2UAhtPsj6q2j_G2d_xBF5M9xXUg/w427-h442/image_2022-12-29_154811326.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-war-of-art.html',
		},
		{
			title: '94. MINDSET',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg-TH5saolXkc3npfK7-g0YEd6HOQBQqy_DlLkz36k92-LISc0yFupC22pckXguQXmuTw48nmvF4I97I0PReNrl-Fpul7ijH-YAOI-CBo9HKFgIlgzYAP-C02zVHimENHDM24o_HJsx7tnaywhEKPFe9V70EFFqAgWz7vKvMkoZ9Rdyx7yxTrgvXfGflQ/w424-h486/image_2022-12-29_160142166.png',
			src: 'https://summarycentral.blogspot.com/2022/12/mindset-new-psychology-of-success.html',
		},
		{
			title: '95. LETTERS FROM A STOIC',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh0aVXjGj6v-XiT7oI9Ka02zlXgtUTQfS-3W-95ugKWkjZAJbyQRR1msEvH5zPh28kWasvsIaVbWO1p36CcMtKAxPzAepakRmeqxYtLJ2ljzd0lbgCD3aN9tayQhTD0yHVOF5T03lqAm4QxtvBp6CLm40vm1qI9mVBmDGk2mpK_7Bp_weePaI79b7nhkQ/w382-h491/image_2022-12-29_163707550.png',
			src: 'https://summarycentral.blogspot.com/2022/12/letters-from-stoic.html',
		},
		{
			title: '96. THE INNOVATORS DILEMMA',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjVhxsYWbvmovGFqXMujUFviu-l_l7aCYE0ZbvP6fr_EQpq394DuLGq7LwBtq98yDbhSuFDP8WRbaIQ9GoC-6YvJSxjCdpTMGBwInXEVjoHxECpdGzpv-cS7rZ_HCMkSZIdpb-D9vbDx4ed7cwg5bluhfgeMscfMqUGAHIupLED1ic8QJH3ml9BKfQtPQ/w365-h428/image_2022-12-29_190815178.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-innovators-dilemma.html',
		},
		{
			title: '97. HOOKED: HOW TO BUILD HABIT-FORMING PRODUCTS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiO3jAUH7vEGqAj3gL4z-cw1Lt5ZPHYhrtELXVdT_5lR0-Og4doOtRZe_zS_NZtOf5uXt1Urb4jtPaAqmWTGCePIPznPIJD4lRoqWc_YV1a4vYLEQjmrjGPX7AxTRYVvTfK6zHkNFXg6sT5MRy36uK0bKpPruErTbtP9_krOiy9smN9j9xvjzJaPYed3g/w378-h421/image_2022-12-29_191542000.png',
			src: 'https://summarycentral.blogspot.com/2022/12/hooked-how-to-build-habit-forming.html',
		},
		{
			title: '98. SHOE DOG',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg2xv2qMsOoNxCJS0xmZ7R_VUBP7y2Qjms-Tew7JXIkysGfXYlXNU3gVWtjHPnyTFJbBYny_Trl4o9QlmCYBpXKNvP7Qvd-GUp41jZE5VUMN7xVv6OI67XyTjrT6o12d3ejWTzyfjdZQ6y6YyJAI55emzLt9QT3AieTHLuJjag953dFOa40nZcvn3lH2A/w529-h352/image_2022-12-29_195803318.png',
			src: 'https://summarycentral.blogspot.com/2022/12/shoe-dog.html',
		},
		{
			title: '99. THE FAULT IN OUR STARS',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjG5ZdHHwNL9K2mZWzzm4B0-52GvDtiUOY9_IGD3zqQ3P3KpNVEsIs7svOsVaUsojO4E4-ljhQzylEXzrtUyOLCDodZS3wQ3XeKVMl91f0l5TpXDECY78lgdYzg8wfriSclNyzqWJkVXe4au7vLvYdvNGJqUFCUp6Pj9LI5Q7HjzIOLdtR8KvY9ifP7_g/w402-h482/image_2022-12-29_201206001.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-fault-in-our-stars.html',
		},
		{
			title: '100. THE ART OF THINKING CLEARLY',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjYJjosKyyUp0xzlpYAH1EEnkzcmBXOXnlnR24Ofh5r1suxETzY8iBlHlPZ2kgsZGky2QvJ5QxCWhijuxNJC1ltMFy-7QxTI28G4nLVW3f11gDUxMIV3731-bMQs8LCeElt4FR89QWX05un8WN3rO8t9_wDKdFecBoOucUaJw4qFqy8EV9Rh79WWTK8Pw/w566-h377/image_2022-12-29_203227016.png',
			src: 'https://summarycentral.blogspot.com/2022/12/the-art-of-thinking-clearly.html',
		},
		{
			title: '',
			desc: '',
			img: '',
			src: '',
		},
		
		
	],
	FinAcademy: [
		{
			title: 'Consulting Interview Preparation (for undergrads)',
			desc: 'Step-by-step case interview preparation guide to help you get offers from top consulting firms like McKinsey, BCG, Bain, Deloitte, and more',
			img: 'https://cms-assets.themuse.com/media/lead/_1200x630_crop_center-center_82_none/25564.jpg?mtime=1568838690',
			href: '/courses/0',
		},
		{
			title: 'Mastering the Case: Interview Case Study Prep',
			desc: 'Develop the expertise and problem-solving prowess necessary to excel in case interviews, empowering participants to confidently analyze and crack complex business cases in a competitive interview setting',
			img: 'https://i.ibb.co/nLwDxT7/case-study-interview.png',
			href: '/courses/1',
		},
		{
			title: 'The Winning Edge: Crafting Captivating Case Study Decks',
			desc: 'Comprehensive guide to designing visually compelling and impactful case study presentations, equipping with the skills and techniques to effectively communicate their ideas and insights in a clear and persuasive manner.',
			img: 'https://i.ibb.co/f0q1v18/case-decks-image.png',
			href: '/courses/2',
		},
		{
			title: 'Guesstimate Guru: Mastering the Art of Estimation',
			desc: 'Develop the skills to solve estimation problems accurately and efficiently, utilizing logical reasoning, creative thinking, and problem-solving techniques.',
			img: 'https://i.ibb.co/ZdNXB10/Guesstimates.webp',
			href: '/courses/3',
		},
		{
			title: 'The Secret Sauce of Good Investing',
			desc: 'Things top 1% will never tell you',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg-Ho0WGB5s4INBT8V0MLm6wIVQQ2yGAAZ3lWRTh5XEkrbLBAHsW6vHwQqX-4Aw5l162z583tuoVpOpgri0Ai-WeWPr42ml0gxjrzQ5eZbw4BZaxDmV1Do7R_IIT61grpfWQcPyiaOfZzZHEpJnv-yq5xvji8Cfh60gKLIOrFpPrqYQvXFo5obHKcSe/w612-h343/6.jpg',
			href: '/courses/4',
		},
	],
	'Quick Bites': [
		{
			title: 'How did F1 racing become so hot?',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgP4MOpeQiCWiWoKuq1RjnSPU3Jp_JqrpL2bYA37WdnRsRbGWAkFZdMmOcx5n4UKtJaeSEtstkRZakdx2MDnHA7vrY6W1v1gCC2YH0LRJ21A7TlUpQ8a0L2-bA7CETzGWrBRblGM8ypYI_RXZVXngw9nHpXkXr7FNzVjRwJWW3bdpsTECLKtES93ct4/w634-h357/plot.png',
			src: 'https://mypersonalbaniya.blogspot.com/2022/07/how-did-f1-racing-become-so-hot.html',
		},
		{
			title: '7 Easy Ways To Save Income Tax On Salary',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/a/AVvXsEgFmkvrnXHpQ7yPHqHXYlwR08aItkenKdf9QPuXPyb5MCXa0lSfNrgBpAQmQUvJkyTb0dI8_lF34OeWigaopCFJK1xgj_GsanCws_11WD9VK5zKjGz9u6Ifmg-7ceJ0ZixlTJNIUBCasrvufE7WFY392NeIAPmYX-9LhpVSi9PEZsKnn-67bkgKFQMW=w652-h480',
			src: 'https://mypersonalbaniya.blogspot.com/2022/07/7-easy-ways-to-save-income-tax-on-salary.html',
		},
		{
			title: '6 lessons from letters of Warren Buffet',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhKxIyu7_m6qUV0XZQz2O70-gFXPQFpqrBlqWczcgtaMs4n3imVzgH95Cba1Tk0JQcGoP7g70IQrWOPICf-6dlSpb6Hr8olmoPObyf6MEgtmaC5MwsLQhvgB_6hw9VGYIKqtAPxRjzaiGhrj6_MAhxthlMEgjuB6sZDofYJv8gZwWdxkh3MoRfuMcGZ/w639-h425/image_2022-07-18_011442422.png',
			src: 'https://mypersonalbaniya.blogspot.com/2022/06/6-lessons-from-letters-of-warren-buffet.html',
		},
		{
			title: 'Cryptocurrency as an Investment Option',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/a/AVvXsEhJNnh1ki2tYOgFojmBArw86_eEB5w10Z12HUuAlq07-6nmRLCo7ch8O4NN1nxpLm5TI5RsA7mEFujeMRth3EFr_P9s2lWdz88cLtoLSYmqWXqtIEgG2Zib7qj7eXJTrON4kyeFdgwxexES0GgrXyOrqY1igtw-U5bG0FT0lQvy2e4DXmwhuLdqVkmq=w637-h359',
			src: 'https://mypersonalbaniya.blogspot.com/2022/06/cryptocurrency-as-investment-option.html',
		},
		{
			title: 'Be Finance Smart!',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/a/AVvXsEijun6qyWxVYlbckX_IqVoEuPx31ry75yHtUrjHvx1c7aPU8ibZZkfKDHtKZtXFPUq7Hh5XggW74T0qMaFT21BIk_LFr2dBv1YPc6Yq1_ThsYEIRIJmJgHTR5oatnlV5xqFj3tGK2OlivdH7XPVtPFKltlHVJUMLc2hKbLtyBHYkr3w2pQEnXnH8hM8=w641-h520',
			src: 'https://mypersonalbaniya.blogspot.com/2022/05/be-finance-smart.html',
		},
		{
			title: '6 Golden Rules of Investing',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjwLilBBzDm7w3KQtN5zE0o80IiRN71HY3wgO7eVFz2pdDyBlcaN64femUrA0ay3ZAAqJmwF6yyuAeJHOqOMcaoY8jzp2jgZpy_oE-zmbLJ8AlAx4-ROWuYfPP6bFv7lnxgMsoMu8yhgMij_JA7XFkQ6mLbUL2YVHxfX76f2tQH_UKMPlR1rOC9P-SK/w627-h355/2.jpg',
			src: 'https://mypersonalbaniya.blogspot.com/2022/05/6-golden-rules-of-investing.html',
		},
		{
			title: 'Players in the Stock Market!',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiGR6sjvGjfgvTiLnJYwKmQm17Rz6nMyRde-w4xbsP0N040Zr7FWQJiYVu_FwDgaxQBUBe0URwddeTiuk7zAjOrZ5M452iPNd5AMq2HQDJRxWM81VOWCnhfvlWepkpBtKGkeJ1D5tQ0-MmEvGAyF-Hf7A5SxfNDxfmT-aF7dwKI_k6rL27NGQdZOwnz/w630-h355/1.webp',
			src: 'https://mypersonalbaniya.blogspot.com/2022/05/players-in-stock-market.html',
		},
		],
	Uplift: [
		{
			title: 'Startup K Drama Quotes',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/a/AVvXsEg1PChKnbzE8I8TVpQWtmHAFF7c4ZqhVi9C1L-fEY55Q3RXenG7zQ4kRJbJrTgFMFCVNDhPJdDdBsdRxho_luACnS478u1F7C_82YhaAk3FGNl-Dz4x8sOciPyD0ydu-yM2gZAkjvTNujhjGO9FasYmzX2Axb9haqg6ezNZj8TBAtshz0ZVRXIlZRw2-Q=w637-h637',
			src: 'https://finchaap.blogspot.com/2022/07/startup-k-drama-quotes.html',
		},
		{
			title: 'Vincenzo K drama quotes',
			desc: '',
			img: 'https://blogger.googleusercontent.com/img/a/AVvXsEiv7tQvW2kX_Q4IKbwKL32QYEY4mRlkxm6KB2v2s3B67dVxysv0RMLceCndgKgDScH1vSWvb1HoZNt7nGTcRiJmjzyYIajO2L-6IY6B5BDTLxEXGwMtK7GEDiy_k0azI_t7ok9BvfYPg08-Z80q6ut_pcAhMQOsoxFz9tkb4dUTUSo5UK-ZR-ucIOzp5A=w393-h469',
			src: 'https://finchaap.blogspot.com/2023/02/vincenzo-k-drama-quotes.html',
		},
		],
};
